import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { TranslationsContext } from "../lib/TranslationsContext";
import { DEFAULT_TRANSLATIONS_VALUES } from "../constants";
export var TranslationsProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useState(DEFAULT_TRANSLATIONS_VALUES), params = _b[0], setTranslationsParams = _b[1];
    useEffect(function () {
        setTranslationsParams(props);
    }, [props.defaultLanguage, props.language]);
    var defaultProps = useMemo(function () { return (__assign(__assign({}, params), { setTranslationsParams: setTranslationsParams })); }, [params]);
    return (_jsx(TranslationsContext.Provider, __assign({ value: defaultProps }, { children: children })));
};
